import React from 'react';

const initials = (name) => (name || '?').trim().charAt(0).toUpperCase();

/* Author avatar bubble + name (optionally linked to LinkedIn) + date + read
   time, dot-separated. Shared by the blog listing cards and the article page
   so both read the same. */
const BlogMeta = ({ author, authorLinkedin, dateLabel, readTime, byLabel }) => (
  <p className="v3-blog-meta-row">
    <span className="v3-blog-avatar" aria-hidden="true">{initials(author)}</span>
    <span aria-label={byLabel ? `${byLabel}: ${author}` : author}>
      {authorLinkedin ? (
        <a
          href={authorLinkedin}
          target="_blank"
          rel="noopener noreferrer"
          className="v3-blog-author"
          onClick={(e) => e.stopPropagation()}
        >
          {author}
        </a>
      ) : (
        author
      )}
    </span>
    <span aria-hidden="true">·</span>
    <span>{dateLabel}</span>
    <span aria-hidden="true">·</span>
    <span>{readTime}</span>
  </p>
);

export default BlogMeta;
